import renderComponent, { FieldTypeWithOnlyValues } from '@databases/field-value';
import { ViewComponentProps } from '@databases/fields/view/types';
import { defaultStoreUtils } from '@databases/redux';
import { DatabaseFieldType } from '@databases/types/database';
import { getReferencedJiraValues } from '@databases/utils/database/field-types/jiraIssueDetails';
import { getDatabaseEntryRequired } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;

  > li + li {
    margin-top: 7px;
  }

  .icon {
    // For priority field
    width: 16px;
  }

  img {
    // For images in the description
    max-width: 100%;
    height: auto;
    overflow: hidden;
  }
`;

const JiraIssueDetailsValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.JIRA_ISSUE_DETAILS>
> = ({ contentId, field, entryId }) => {
  const targetValues = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, {
      contentId,
    });
    const entry = entryId ? getDatabaseEntryRequired(database, entryId) : undefined;

    return getReferencedJiraValues({ database, field, entry }, state);
  });

  if (!targetValues.length) {
    return null;
  } else {
    return (
      <Container>
        {targetValues.map((columnData, i) => {
          const values = Array.isArray(columnData.data)
            ? columnData.data
            : [columnData.data];
          return (
            <li key={i}>
              {renderComponent({
                type: columnData.type,
                text: columnData.text,
                values,
              } as FieldTypeWithOnlyValues)}
            </li>
          );
        })}
      </Container>
    );
  }
};

export default JiraIssueDetailsValueView;
